// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-container {
  position: absolute;
  top: 2%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  z-index: 2;
}

.input-field {
  display: flex;
  color: var(--text-primary);
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  padding: 5px;
  border-radius: 4px;
  min-height: 34px;
  align-items: center;
  overflow-x: auto;
}

.selected-genre {
  display: flex;
  align-items: center;
  margin: 2px;
  padding: 2px 5px;
  border-radius: 2px;
  background-color: var(--theme-consistent);
  color: var(--text-primary);
  font-size: 0.9em;
  white-space: nowrap;
}

.remove-genre {
  margin-left: 5px;
  cursor: pointer;
}

.dropdown {
  position: absolute;
  background-color: var(--background);
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  width: 100%;
  max-height: 200px;
  overflow-y: scroll;
  color: var(--text-primary);
  padding: 8px;
  border-radius: 4px;
}

.filter-input {
  width: 100%;
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  border: var(--theme-consistent);
  padding: 8px;
}

.dropdown-option {
  padding: 10px;
}

.hide {
  display: none;
}

.ratings-container {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 10px;
}

.rating-slider {
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-radius: 4px;
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  background-color: var(--background);
  color: var(--text-primary);
}

.scrollable-container {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  padding: 8px;
  padding-bottom: 225px;
  background: var(--background);
}

.typed-strings {
  color: var(--text-primary);
  font-size: 1.2em;
}

.plex-library-selector {
  margin-top: 20px;
  position: relative;
}

.plex-library-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 4px;
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  background-color: var(--background);
  color: var(--text-primary);
  cursor: pointer;
}

.plex-library-options {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: var(--background);
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  border-radius: 4px;
  padding: 8px;
  z-index: 2;
}

.plex-library-option {
  display: flex;
  align-items: center;
  padding: 5px;
}

.plex-library-option input[type="checkbox"] {
  display: none;
}

.plex-library-option label {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  line-height: 20px;
  color: var(--text-primary);
}

.plex-library-option label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--theme-consistent);
  background-color: var(--background);
  transition: background-color 0.3s ease;
}

.plex-library-option input[type="checkbox"]:checked + label::before {
  background-color: var(--theme-consistent);
}

.plex-library-option label::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.plex-library-option input[type="checkbox"]:checked + label::after {
  opacity: 1;
}

.arrow {
  border: solid var(--text-primary);
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  margin-left: 5px;
}

.arrow.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.arrow.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.collections-container {
  margin-top: 20px;
}

.collection-type {
  margin-bottom: 20px;
}

.collection-type-title {
  font-size: 1.2em;
  color: var(--text-primary);
  margin-bottom: 10px;
}

.collection-option {
  display: flex;
  align-items: center;
  padding: 5px;
}

.collection-option input[type="checkbox"] {
  margin-right: 10px;
}

.collection-option label {
  color: var(--text-primary);
}

.collections-selector {
  margin-top: 20px;
  position: relative;
}

.collections-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 4px;
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  background-color: var(--background);
  color: var(--text-primary);
  cursor: pointer;
}

.collections-options {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: var(--background);
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  border-radius: 4px;
  padding: 8px;
  z-index: 2;
}

.collection-type {
  margin-bottom: 20px;
}

.collection-type-title {
  font-size: 1.2em;
  color: var(--text-primary);
  margin-bottom: 10px;
}

.collection-option {
  display: flex;
  align-items: center;
  padding: 5px;
}

.collection-option input[type="checkbox"] {
  display: none;
}

.collection-option label {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  line-height: 20px;
  color: var(--text-primary);
}

.collection-option label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--theme-consistent);
  background-color: var(--background);
  transition: background-color 0.3s ease;
}

.collection-option input[type="checkbox"]:checked + label::before {
  background-color: var(--theme-consistent);
}

.collection-option label::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.collection-option input[type="checkbox"]:checked + label::after {
  opacity: 1;
}

.collection-type {
  margin-bottom: 20px;
}

.collection-type-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 4px;
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  background-color: var(--background);
  color: var(--text-primary);
  cursor: pointer;
}

.collection-type-options {
  max-height: 200px;
  overflow-y: auto;
  background-color: var(--background);
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  border-radius: 4px;
  padding: 8px;
}

.collection-option {
  display: flex;
  align-items: center;
  padding: 5px;
}

.collection-option input[type="checkbox"] {
  display: none;
}

.collection-option label {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  line-height: 20px;
  color: var(--text-primary);
}

.collection-option label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--theme-consistent);
  background-color: var(--background);
  transition: background-color 0.3s ease;
}

.collection-option input[type="checkbox"]:checked + label::before {
  background-color: var(--theme-consistent);
}

.collection-option label::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.collection-option input[type="checkbox"]:checked + label::after {
  opacity: 1;
}

.filter-actions {
  position: fixed;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%; /* Match the filter-container width */
  padding: 1rem;
  display: flex;
  justify-content: center;
  /* z-index: 1; Ensure it stays above other elements */
}

/* Update the button styling to be more prominent */
.apply-filters-btn {
  padding: 0.75rem 2rem;
  background-color: var(--theme-consistent);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 260px;
  box-shadow: 0px 0px 8px 3px rgba(0,0,0,0.33);
  font-size: 1.6rem;
}

/* Style for the close button state */
.apply-filters-btn:not([disabled]):not(:hover) {
  background-color: var(--theme-consistent);
}

/* When it's in "Close" state */
.apply-filters-btn:not([disabled])[onclick*="setDropdownVisible"] {
  background-color: #6c757d; /* or any other color you prefer */
}

.apply-filters-btn:hover {
  background-color: #ff6347;
  transform: translateY(-1px);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.apply-filters-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.scrollable-container,
.dropdown,
.plex-library-options,
.collection-type-options {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

/* Hide WebKit (Chrome, Safari, etc.) scrollbars */
.scrollable-container::-webkit-scrollbar,
.dropdown::-webkit-scrollbar,
.plex-library-options::-webkit-scrollbar,
.collection-type-options::-webkit-scrollbar {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/DeckFiltering.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mDAAmD;EACnD,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,mDAAmD;EACnD,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mDAAmD;EACnD,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,mDAAmD;EACnD,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mDAAmD;EACnD,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,mDAAmD;EACnD,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yCAAyC;EACzC,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mDAAmD;EACnD,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,mDAAmD;EACnD,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yCAAyC;EACzC,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mDAAmD;EACnD,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,mDAAmD;EACnD,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yCAAyC;EACzC,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,UAAU,EAAE,qCAAqC;EACjD,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,gBAAgB;AAC5C;;AAEA,kDAAkD;AAClD;;;;EAIE,aAAa;AACf","sourcesContent":[".filter-container {\n  position: absolute;\n  top: 2%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 90%;\n  z-index: 2;\n}\n\n.input-field {\n  display: flex;\n  color: var(--text-primary);\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  padding: 5px;\n  border-radius: 4px;\n  min-height: 34px;\n  align-items: center;\n  overflow-x: auto;\n}\n\n.selected-genre {\n  display: flex;\n  align-items: center;\n  margin: 2px;\n  padding: 2px 5px;\n  border-radius: 2px;\n  background-color: var(--theme-consistent);\n  color: var(--text-primary);\n  font-size: 0.9em;\n  white-space: nowrap;\n}\n\n.remove-genre {\n  margin-left: 5px;\n  cursor: pointer;\n}\n\n.dropdown {\n  position: absolute;\n  background-color: var(--background);\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: scroll;\n  color: var(--text-primary);\n  padding: 8px;\n  border-radius: 4px;\n}\n\n.filter-input {\n  width: 100%;\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  border: var(--theme-consistent);\n  padding: 8px;\n}\n\n.dropdown-option {\n  padding: 10px;\n}\n\n.hide {\n  display: none;\n}\n\n.ratings-container {\n  margin-top: 20px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  grid-gap: 10px;\n}\n\n.rating-slider {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  border-radius: 4px;\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  background-color: var(--background);\n  color: var(--text-primary);\n}\n\n.scrollable-container {\n  max-height: calc(100vh - 150px);\n  overflow-y: auto;\n  padding: 8px;\n  padding-bottom: 225px;\n  background: var(--background);\n}\n\n.typed-strings {\n  color: var(--text-primary);\n  font-size: 1.2em;\n}\n\n.plex-library-selector {\n  margin-top: 20px;\n  position: relative;\n}\n\n.plex-library-dropdown {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  border-radius: 4px;\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  background-color: var(--background);\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.plex-library-options {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: var(--background);\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  border-radius: 4px;\n  padding: 8px;\n  z-index: 2;\n}\n\n.plex-library-option {\n  display: flex;\n  align-items: center;\n  padding: 5px;\n}\n\n.plex-library-option input[type=\"checkbox\"] {\n  display: none;\n}\n\n.plex-library-option label {\n  position: relative;\n  padding-left: 30px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n\n.plex-library-option label::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid var(--theme-consistent);\n  background-color: var(--background);\n  transition: background-color 0.3s ease;\n}\n\n.plex-library-option input[type=\"checkbox\"]:checked + label::before {\n  background-color: var(--theme-consistent);\n}\n\n.plex-library-option label::after {\n  content: \"\";\n  position: absolute;\n  left: 6px;\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.plex-library-option input[type=\"checkbox\"]:checked + label::after {\n  opacity: 1;\n}\n\n.arrow {\n  border: solid var(--text-primary);\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 3px;\n  margin-left: 5px;\n}\n\n.arrow.down {\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n\n.arrow.up {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n\n.collections-container {\n  margin-top: 20px;\n}\n\n.collection-type {\n  margin-bottom: 20px;\n}\n\n.collection-type-title {\n  font-size: 1.2em;\n  color: var(--text-primary);\n  margin-bottom: 10px;\n}\n\n.collection-option {\n  display: flex;\n  align-items: center;\n  padding: 5px;\n}\n\n.collection-option input[type=\"checkbox\"] {\n  margin-right: 10px;\n}\n\n.collection-option label {\n  color: var(--text-primary);\n}\n\n.collections-selector {\n  margin-top: 20px;\n  position: relative;\n}\n\n.collections-dropdown {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  border-radius: 4px;\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  background-color: var(--background);\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.collections-options {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: var(--background);\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  border-radius: 4px;\n  padding: 8px;\n  z-index: 2;\n}\n\n.collection-type {\n  margin-bottom: 20px;\n}\n\n.collection-type-title {\n  font-size: 1.2em;\n  color: var(--text-primary);\n  margin-bottom: 10px;\n}\n\n.collection-option {\n  display: flex;\n  align-items: center;\n  padding: 5px;\n}\n\n.collection-option input[type=\"checkbox\"] {\n  display: none;\n}\n\n.collection-option label {\n  position: relative;\n  padding-left: 30px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n\n.collection-option label::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid var(--theme-consistent);\n  background-color: var(--background);\n  transition: background-color 0.3s ease;\n}\n\n.collection-option input[type=\"checkbox\"]:checked + label::before {\n  background-color: var(--theme-consistent);\n}\n\n.collection-option label::after {\n  content: \"\";\n  position: absolute;\n  left: 6px;\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.collection-option input[type=\"checkbox\"]:checked + label::after {\n  opacity: 1;\n}\n\n.collection-type {\n  margin-bottom: 20px;\n}\n\n.collection-type-dropdown {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  border-radius: 4px;\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  background-color: var(--background);\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.collection-type-options {\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: var(--background);\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  border-radius: 4px;\n  padding: 8px;\n}\n\n.collection-option {\n  display: flex;\n  align-items: center;\n  padding: 5px;\n}\n\n.collection-option input[type=\"checkbox\"] {\n  display: none;\n}\n\n.collection-option label {\n  position: relative;\n  padding-left: 30px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n\n.collection-option label::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid var(--theme-consistent);\n  background-color: var(--background);\n  transition: background-color 0.3s ease;\n}\n\n.collection-option input[type=\"checkbox\"]:checked + label::before {\n  background-color: var(--theme-consistent);\n}\n\n.collection-option label::after {\n  content: \"\";\n  position: absolute;\n  left: 6px;\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.collection-option input[type=\"checkbox\"]:checked + label::after {\n  opacity: 1;\n}\n\n.filter-actions {\n  position: fixed;\n  bottom: 100px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 90%; /* Match the filter-container width */\n  padding: 1rem;\n  display: flex;\n  justify-content: center;\n  /* z-index: 1; Ensure it stays above other elements */\n}\n\n/* Update the button styling to be more prominent */\n.apply-filters-btn {\n  padding: 0.75rem 2rem;\n  background-color: var(--theme-consistent);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  min-width: 260px;\n  box-shadow: 0px 0px 8px 3px rgba(0,0,0,0.33);\n  font-size: 1.6rem;\n}\n\n/* Style for the close button state */\n.apply-filters-btn:not([disabled]):not(:hover) {\n  background-color: var(--theme-consistent);\n}\n\n/* When it's in \"Close\" state */\n.apply-filters-btn:not([disabled])[onclick*=\"setDropdownVisible\"] {\n  background-color: #6c757d; /* or any other color you prefer */\n}\n\n.apply-filters-btn:hover {\n  background-color: #ff6347;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.apply-filters-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.scrollable-container,\n.dropdown,\n.plex-library-options,\n.collection-type-options {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE and Edge */\n}\n\n/* Hide WebKit (Chrome, Safari, etc.) scrollbars */\n.scrollable-container::-webkit-scrollbar,\n.dropdown::-webkit-scrollbar,\n.plex-library-options::-webkit-scrollbar,\n.collection-type-options::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
